export default __webpack_public_path__ + "static/media/gift-icon.874a017a.svg";